// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 全局样式
import 'minireset.css/minireset.css'
// import 'element-ui/lib/theme-chalk/index.css'
// 三方插件
// 按需引入ElementUI
import './element-ui'
// 主题修改文件
import '../theme/index.css'
// 引入VUX
import store from './store'
// 插件配置
import axios from './axios'
import router from './router'
//轮播组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'default-passive-events'
Vue.use(VueAwesomeSwiper)
import './utils/countTime'
// 根组件
import App from './App'

Vue.config.productionTip = false
// 开发环境启动Mock
// process.env.NODE_ENV === 'development' && import('@/mock')

// 挂载自定义axios实例在Vue的原型链上，使用时使用this.$axios(...)
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, // 注入路由
  store, // 注入Store
  components: {App},
  template: '<App/>'
})


// 日期格式化扩展
Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1,                 //月份
    "d+": this.getDate(),                    //日
    "h+": this.getHours(),                   //小时
    "m+": this.getMinutes(),                 //分
    "s+": this.getSeconds(),                 //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}



// WEBPACK FOOTER //
// ./src/main.js